export const hasAttachmentValidPDFMarker = async (attachment?: File): Promise<boolean> => {
  if (!attachment) {
    return false;
  }
  try {
    const preamble = await attachment.slice(0, 1024).text();
    return preamble.includes('%PDF-');
  } catch {
    return false;
  }
};

export const hasAttachmentValidSize = (attachment?: File): boolean => {
  if (!attachment) {
    return false;
  }

  try {
    const isValidSize = attachment.size > 4 && attachment.size < 10485760;

    return isValidSize;
  } catch {
    return false;
  }
};

export const hasAttachmentValidFileExt = (attachment?: File): boolean => {
  if (!attachment) {
    return false;
  }

  try {
    const name = attachment?.name ?? '';
    const dotIndex = name.lastIndexOf('.');
    const ext = dotIndex !== -1 ? name.slice(dotIndex) : '';
    return ext.toLowerCase() === '.pdf';
  } catch {
    return false;
  }
};
